export default {
  defaultGap: '32px',
  smallGap: '20px',
  extraSmallGap: '16px',
};
